import { Column, Row } from '@bfa/common-ui';
import { externalRedirect } from '@bfa/nextjs-common/utils';
import get from 'lodash/get';
import React from 'react';

import Layout from '../../../components/Layout';
import { ABSOLUTE_URLS } from '../../../constants';
import { logAnalyticsEvent } from '../../../utils/analytics';
import { AnalyticsEventKey } from '../../../utils/analytics/constants';
import { AnalyticsEvent } from '../../../utils/types';
import Popup from '../components/Popup';
import useGetAlert from './hooks/useGetAlert';

type Props = {
  cross: boolean;
};

const getEventData = (
  name: AnalyticsEventKey,
  label: string
): AnalyticsEvent => ({
  name,
  label,
});

const FlashSales = ({ cross }: Props) => {
  const [trackSent, setTrackSent] = React.useState(false);
  const FLASH_SALES_POPUP = 'FLASH_SALES_POPUP';
  const { data } = useGetAlert({ alertId: 'flash-sales-popup' });

  const alert = get(data, 'me.alert');

  React.useEffect(() => {
    if (!trackSent) {
      logAnalyticsEvent(getEventData(FLASH_SALES_POPUP, 'Viewed Pop Up'));
      setTrackSent(true);
    }
  }, [trackSent]);

  const trackDismiss = React.useCallback(() => {
    logAnalyticsEvent(getEventData(FLASH_SALES_POPUP, 'Clicked Dismiss'));
  }, []);

  const trackConfirm = React.useCallback(() => {
    logAnalyticsEvent(getEventData(FLASH_SALES_POPUP, 'Clicked Shop Now'));
  }, []);

  const trackMaybe = React.useCallback(() => {
    logAnalyticsEvent(getEventData(FLASH_SALES_POPUP, 'Clicked Maybe Later'));
  }, []);

  const trackLogo = React.useCallback(() => {
    logAnalyticsEvent(getEventData(FLASH_SALES_POPUP, 'Clicked IPSY logo'));
  }, []);

  return (
    <Layout
      header={{
        minimum: true,
        cross,
        onCrossClick: () => {
          trackDismiss();
          externalRedirect(ABSOLUTE_URLS.GLAM_BAG);
        },
        onLogoClick: () => {
          trackLogo();
        },
      }}
      footer={false}
    >
      <Row>
        <Column xs={12} xsOffset={0} sm={8} smOffset={2} md={6} mdOffset={3}>
          <Popup
            withSeparator
            {...alert}
            primaryActionOnClick={() => {
              trackConfirm();
            }}
            secondaryActionOnClick={() => {
              trackMaybe();
            }}
          />
        </Column>
      </Row>
    </Layout>
  );
};

export default FlashSales;
